import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesScreenSchemesEntityRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-screen-schemes-entity',
	path: '/secure/admin/ViewEditIssueTypeScreenSchemeEntity.jspa',
};
